import React, { useCallback } from 'react';
import {
  FormControl,
  FormHelperText,
  Icon,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import styles from './CreateParentProfile.module.css';
import { MobileStepIndicator } from '../../../../component/signup/mobileStepIndicator/mobileStepIndicator';
import { CreateParentProfileElement } from '../CreateParentProfileElement';

export const MobileView = (): JSX.Element => {
  const createParentProfileElement = CreateParentProfileElement();
  return (
    <React.Fragment>
      <div className={styles.createParentProfile2}>
        <header className={styles.headerGroup} id="common-navi-bar">
          <img
            className={styles.bbaLogoIcon}
            id="entry-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
        </header>
        <main className={styles.createParentProfileMainGroDiv}>
          <div className={styles.createParentProfileTitleGrDiv}>
            <img
              className={styles.mobileBackIcon}
              id="mobile-back-icon"
              alt=""
              src="assets/common/mobile-back-icon.svg"
              onClick={createParentProfileElement.backButtonClickHandler}
            />
            <div className={styles.createParentProfileTitleDiv}>
              Create Parent Profile
            </div>
          </div>
          <div className={styles.createParentProfileInputGrDiv}>
            <div className={styles.inputTextFirstName}>
              {createParentProfileElement.firstNameInput}
            </div>
            <div className={styles.inputTextFirstName}>
              {createParentProfileElement.lastNameInput}
            </div>
            <div className={styles.frameDiv1}>
              <div className={styles.createParentProfileInputPhDiv}>
                {createParentProfileElement.phoneNumberInput}
              </div>
              <div className={styles.assistiveTextDiv}>
                Big Bang Academy uses the phone number to assist you for any
                questions you may have.
              </div>
            </div>
            <div className={styles.createParentProfileInputPaDiv}>
              <div className={styles.createParentProfileInputPaTextField}>
                {createParentProfileElement.passwordInput}
              </div>
            </div>

            <button className={styles.createParentProfileNextButButton}>
              <div className={styles.smallDiv}>
                {createParentProfileElement.continueButton}
              </div>
            </button>
          </div>
        </main>
        <footer className={styles.progressIndicatorsFooter}>
          <MobileStepIndicator step={2} totalStep={4} />
        </footer>
      </div>
    </React.Fragment>
  );
};
